const setEntityName = (name: string) => ({
  type: 'SET_ENTITY_NAME',
  name,
})

export default setEntityName
